module.exports = new __parcel__URL__("donkey-kong-country-tropical-freeze.ef16120a.jpg").toString();